module.exports = __webpack_public_path__ + "static/media/successIcon.7a767701.svg";